import { render, staticRenderFns } from "./chakan.vue?vue&type=template&id=6e66a83b&scoped=true"
import script from "./chakan.vue?vue&type=script&lang=js"
export * from "./chakan.vue?vue&type=script&lang=js"
import style0 from "./chakan.vue?vue&type=style&index=0&id=6e66a83b&prod&lang=less&scoped=true"
import style1 from "./chakan.vue?vue&type=style&index=1&id=6e66a83b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e66a83b",
  null
  
)

export default component.exports